<template>
    <!-- 时间选择 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.Timing')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
                @click="setActiveInput(question.qid)">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				
                <TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
                ></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        <el-row
            :gutter="10"
            style="margin-top: 12px !important;margin-bottom: 14px"
        >
            <div  style="margin-left: 50px">
                <!-- <el-time-picker
                    disabled
                    format="HH:mm"
                    value-format="HH:mm"
                    v-model="timeValue"
                    placeholder="选择时间">
                </el-time-picker> -->
                
                <div class="imitation-form-input-text imitation-form-input-date">
                <i class="el-icon-time"></i>
                {{$t('main.SelectTime')}}</div>
            </div>
        </el-row>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import OperateWrap from "./collectToBank/operateaWrap.vue"
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        components:{
            TitleEditor,
            OperateWrap
        },
        data() {
            return {
                editOptionIndex: "0_0",
                options1: [],
                options2: [],
                value1: '',
                value2:'',
                timeValue: '',
            }
        },
        props: {
            question: {},
            index: {type:Number,default:0},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            
        },
        created() {
           // console.log('questionTime',this.question)
        },
        mounted(){
            for(let i =0; i<24;i++) {
                if(i<10){
                    i = '0' + i
                }
                this.options1.push({value:i})
            }
            for(let i =0; i<60;i++) {
                if(i<10){
                    i = '0' + i
                }
                this.options2.push({value:i})
            }
            console.log(this.options1, this.options2)
        }
    }
</script>

<style scoped lang="scss">
    .questiontime{
        margin-left:40px;
        margin-top:-10px;
        margin-bottom:10px;
    }
    .questiontime .fake-input{
        width: 160px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-top: 10px;
        text-indent: 20px;
        display: inline-block;
    }
    .el-date-editor--time .el-input__inner {
        border: 1px solid #DCDFE6 !important;
        background-color: #FFF;
    }
    .el-date-editor{
        margin-left: 50px;
        margin-bottom: 24px;
        margin-top: 12px !important;
    }
    /deep/.questiontime .el-input__inner{
        border:1px solid #ccc !important;
    }
    .el-input--suffix .el-input__inner{
        border:1px solid #ccc;
    }
    /* .el-date-editor{
        width:600px;
        height:40px;
        border:1px solid #ccc;
        margin-bottom:20px;
    } */
    /* /deep/.el-input__prefix{
        right:-560px !important;
    }
    /deep/.el-input__prefix i{
        color:#ccc;
    }
    /deep/.el-input__suffix{
        display:none !important;
    } */
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        // height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }


</style>
